<template>
    <div class='account_add_edit zc_dialog_box'>
        <el-dialog :visible.sync="dialogVisible" width="534px" :close-on-click-modal='false' @close='cancelBtn'>
            <div slot="title">
                <div class="name">{{ title }}</div>
            </div>
            <div class="inv_main">
                <div class="main_text">
                    <div class="left"><span>*</span>描述</div>
                    <div class="right">
                        <el-input v-model="info.describe" placeholder="请输入描述">
                        </el-input>
                    </div>
                </div>
                <div class="main_text">
                    <div class="left"><span>*</span>图片</div>
                    <div class="right">
                        <el-upload class="r_img" accept="image/jpg,image/jpeg,image/png,image/gif" action="" :before-upload="beforeAvatarUpload" :http-request="httpRequestMultiple" :show-file-list="false">
                            <div v-if="info.cover" class="w100 h100">
                                <img class="w100 h100" :src="info.cover" alt="">
                            </div>
                            <div class="r_img_no w100 h100" v-else>
                                <i class="el-icon-plus"></i>
                                <div>上传图片</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="main_text">
                    <div class="left"><span>*</span>跳转地址</div>
                    <div class="right">
                        <el-radio v-model="info.type" :label="1">内部跳转</el-radio>
                        <el-radio v-model="info.type" :label="2">外部跳转</el-radio>
                    </div>
                </div>
                <div class="main_text">
                    <div class="left"><span>*</span>跳转地址</div>
                    <div class="right">
                        <el-input v-model="info.path" placeholder="请输入跳转地址">
                        </el-input>
                    </div>
                </div>
            </div>
            <div slot="footer" style="padding: 0 20px;">
                <el-button class="btnBgColor_grey" size="small" @click="cancelBtn">取 消</el-button>
                <el-button class="btnBgColor_blue" size="small" :loading='btnLoading' type="primary" @click="affirmBtn">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        type: {
            type: Number,
            defaul: 1
        },
    },
    data() {
        return {
            headers: {
                'Authorization': this.$store.state.token
            },
            dialogVisible: false,
            info: {
                cover: "",
                type: 1,
                path: "",
                describe: "",
            },
            id: '',
            btnLoading: false,
        }
    },
    computed: {
        title() {
            return this.type == 1 ? '新增' : '编辑'
        },
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {
        // 打开弹框
        openDialogBtn(val) {
            if (val) {
                this.info = {
                    cover: val.cover,
                    type: val.type,
                    path: val.path,
                    describe: val.describe,
                }
                this.id = val.id
            }
            this.dialogVisible = true
        },
        // 取消
        cancelBtn() {
            this.info = {
                cover: "",
                type: 1,
                path: "",
                describe: "",
            }
            this.dialogVisible = false
        },
        // 确定
        affirmBtn() {
            var that = this
            if (that.info.cover == '') {
                that.$errMsg('请上传图片')
                return
            } else if (that.info.describe == '') {
                that.$errMsg('请输入描述')
                return
            } else if (that.info.path == '') {
                that.$errMsg('请输入跳转地址')
                return
            } else if (that.type == 1) {
                // 添加
                that.btnLoading = true
                var params = {
                    ...this.info
                }
                that.$activityApi.advertAdd(params).then(res => {
                    that.btnLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('submit')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            } else if (that.type == 2) {
                // 编辑
                that.btnLoading = true
                var params = {
                    ...this.info
                }
                that.$activityApi.advertEdit(params, that.id).then(res => {
                    that.btnLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('submit')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }
        },
        // 上传图片限制
        beforeAvatarUpload(file) {
            const isLt10KB = file.size / 1024 / 1024 < 10;
            let types = ['image/jpg', 'image/png', 'image/gif', 'image/jpeg'];
            const isType = types.includes(file.type);
            if (!isType) {
                this.$message.error('只能上传只 JPG/PNG/JEPG/GIF 格式!');
            }
            if (!isLt10KB) {
                this.$message.error('上传图片大小不能超过 10M!');
            }

            return isType && isLt10KB;
        },

        // 上传图片
        httpRequestMultiple(uploader) {
            const formData = new FormData();
            formData.set('file', uploader.file);
            this.$publicApi.uploadFile(formData).then(res => {
                if (res.code === 1000) {
                    this.info.cover = res.result.url
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    },
}
</script>

<style lang='scss' scoped>
.account_add_edit {
    .inv_main {
        width: 100%;
        padding: 10px 20px 0 0;

        .main_text {
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;

            .left {
                width: 90px;
                line-height: 40px;
                text-align: right;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;

                span {
                    color: #e00c25;
                }
            }

            .right {
                width: 370px;

                .el-input {
                    width: 100%;
                }

                .el-select {
                    width: 100%;
                }
                .el-cascader {
                    width: 100%;
                }
                .right_txt {
                    padding-top: 10px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ff2b2b;
                }

                .r_img {
                    width: 80px;
                    height: 80px;
                    cursor: pointer;
                    border: 1px solid #e8eaec;
                    background-color: #f5f7fa;
                    border-radius: 5px;
                    text-align: center;
                    .r_img_no {
                        padding-top: 20px;
                        font-size: 14px;
                        color: #94979f;
                        i {
                            font-size: 18px;
                        }
                        div {
                            padding-top: 5px;
                        }
                    }
                }
            }
        }
        .main_text:last-child {
            margin-bottom: 0;
        }
    }
}
.w100 {
    width: 100%;
}
.h100 {
    height: 100%;
}

::v-deep .el-radio {
    line-height: 40px;
}
</style>
